import { Button } from "@/shared/ui/button";
import type { LucideIcon } from "lucide-react";

interface FileMetadataFieldProps {
  label: string;
  value: string | number | undefined;
  children?: React.ReactNode;
  actionIcon?: LucideIcon;
  onActionClick?: () => void;
}

export function FileMetadataField({
  label,
  value,
  children,
  actionIcon: ActionIcon,
  onActionClick,
}: FileMetadataFieldProps) {
  if (value === undefined && !children) {
    return null;
  }

  return (
    <div>
      <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-wider text-ink-500">
          {label}
        </p>
        {ActionIcon && onActionClick && (
          <Button
            variant="ghost"
            size="icon"
            className="h-6 w-6"
            onClick={onActionClick}
            aria-label={`Edit ${label.toLowerCase()}`}
          >
            <ActionIcon className="h-3.5 w-3.5" />
          </Button>
        )}
      </div>
      {children || <p className="mt-1 text-sm text-ink-900">{value}</p>}
    </div>
  );
}
